var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-component',{attrs:{"title":"Application Error"}}),_c('application-submit-error-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }